// setProgress('.progress', 42)
window.setProgress = (selector, v) => {
    document.querySelectorAll(selector).forEach(el => el.style.setProperty('--value', v));
};

